import React from 'react'
import ReactHlsPlayer from '@gumlet/react-hls-player'
import {VideoHLSPlayerProps} from './VideoHLSPlayerProps'

export default function VideoHLSPlayer(props: VideoHLSPlayerProps) {
  return <ReactHlsPlayer {...props} />
}
